const INITIAL_STATE = {
  data: {},
  errors: {},
}
  
const getServiceFilterList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_SERVICE_ORDER_FILTER':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_SERVICE_ORDER_FILTER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default getServiceFilterList;
  